var _rect, _rect2, _rect3, _rect4, _rect5, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSiteTraficSample(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.8297,
    y: 36.2551,
    width: 4.09972,
    height: 4.783,
    rx: 0.377012,
    fill: "#C9DBFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.2969,
    y: 31.4714,
    width: 4.10065,
    height: 9.56819,
    rx: 0.377012,
    fill: "#C9DBFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 23.7649,
    y: 27.3718,
    width: 4.10065,
    height: 13.6688,
    rx: 0.377012,
    fill: "#C9DBFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 29.2321,
    y: 22.5884,
    width: 4.10064,
    height: 18.4529,
    rx: 0.377012,
    fill: "#C9DBFF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 34.7002,
    y: 19.1716,
    width: 4.10065,
    height: 21.8701,
    rx: 0.377012,
    fill: "#C9DBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.9794 13.1471C39.1846 13.3523 39.5351 13.2584 39.6102 12.9781L41.57 5.66395C41.6451 5.38362 41.3886 5.1271 41.1083 5.20221L33.7941 7.16203C33.5138 7.23715 33.4199 7.58756 33.6251 7.79278L34.8871 9.05477C35.0343 9.202 35.0343 9.44071 34.8871 9.58795L25.4855 18.9896C25.3382 19.1368 25.0995 19.1368 24.9523 18.9896L20.3656 14.4028C20.354 14.3912 20.3418 14.3805 20.3292 14.3708C20.3138 14.3589 20.2984 14.3469 20.2847 14.3331C20.1738 14.2223 19.994 14.2223 19.8832 14.3331L6.52717 27.6891C6.37994 27.8364 6.37994 28.0751 6.52717 28.2223L8.41033 30.1055C8.55756 30.2527 8.79627 30.2527 8.9435 30.1055L19.8229 19.226C19.9702 19.0788 20.2089 19.0788 20.3561 19.226L24.9463 23.8163C25.0936 23.9635 25.3323 23.9635 25.4795 23.8163L25.4896 23.8062C25.5084 23.7873 25.5297 23.7711 25.5504 23.7543C25.5607 23.746 25.5707 23.737 25.5802 23.7275L37.3034 12.0043C37.4507 11.857 37.6894 11.857 37.8366 12.0043L38.9794 13.1471Z",
    fill: "#9EBAF2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteTraficSample);
export default __webpack_public_path__ + "static/media/site_trafic_sample.6ac9e96e.svg";
export { ForwardRef as ReactComponent };